import useScrollAnimation from './useScrollAnimation'
import { Container, Grid, Box, Typography } from '@mui/material'

const ProjectTracking = () => {
  useScrollAnimation('.tracking')

  return (
    <section className="tracking pad-60">
      <Container>
        <Grid container alignItems="center">
          {/* Left Side Image */}
          <Grid item lg={7} md={7} sm={7} xs={12} className="left-image">
            <Box className="tracking-btn" sx={{ width: '400px' }}>
              <Box
                component="img"
                src="/assets/document-templates/tracking-btn.svg"
                alt="tracking button"
              />
            </Box>
            <Box
              component="img"
              src="/assets/document-templates/tracking.svg"
              alt="Material Planning"
              className="img-fluid"
            />
          </Grid>

          {/* Right Side Content */}
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <Typography variant="h2" className="mb-4 main_titel">
              Boost team performance and accelerate <span> decision-making</span> with Epoch 7
            </Typography>
            <Box className=" mb-3">
              <Typography variant="body1">
                Struggling to keep up with tasks and decisions? Feeling overwhelmed and
                unproductive? It's time to streamline your processes and unlock your team's full
                potential. ​
              </Typography>
            </Box>

            <Box className=" mb-3">
              <Typography variant="body1">
                Revolutionize the way you tackle challenges, meet deadlines, and achieve your goals.
                Harness the power of efficient time and data management, and watch your team reach
                new heights of performance!​
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

export default ProjectTracking
